import styled from 'styled-components';
import { gridConfig as breakpoints } from '../../fuse-responsive-grid/src/grid';
import { Swatch } from '../../fuse-swatch/src/index';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';
import { visibleSwatchesCount } from './config';

const ColourContainer = styled.div.attrs({
	className: 'fuse-complex-product-card__colour-swatch',
	'data-testid': 'fuse-complex-product-card__colour-swatch',
})`
	display: flex;
	align-items: center;
	padding: var(--spacing-global-space2) 0;
	margin-bottom: var(--spacing-global-space3);
`;

const StyledCount = styled(TypographyComponent).attrs({
	className: 'fuse-complex-product-card__colour-swatch-count',
	'data-testid': 'fuse-complex-product-card__colour-swatch-count',
})`
	.fuse-complex-product-card__colour-swatch & {
		color: var(--color-global-grey900);
		margin: 0;
		margin-left: var(--spacing-global-space3);

		${({ swatchesTotalCount }) => `
			display: ${swatchesTotalCount <= visibleSwatchesCount.xxs.max ? 'none' : 'block'};

			@media screen and (min-width: ${breakpoints.xs.minWidth}) {
				display: ${swatchesTotalCount <= visibleSwatchesCount.xs.max ? 'none' : 'block'};
			}
			@media screen and (min-width: ${breakpoints.m.minWidth}) {
				display: ${swatchesTotalCount <= visibleSwatchesCount.m.max ? 'none' : 'block'};
			}
			@media screen and (min-width: ${breakpoints.l.minWidth}) {
				display: ${swatchesTotalCount <= visibleSwatchesCount.l.max ? 'none' : 'block'};
			}
			@media screen and (min-width: ${135 * 0.625}rem) {
				display: ${swatchesTotalCount <= visibleSwatchesCount['1350'].max ? 'none' : 'block'};
			}
		`}
	}
`;

function isSwatchInvisible(swatchNumber, swatchesTotalCount, device) {
	return (
		(swatchesTotalCount > visibleSwatchesCount[device].max &&
			swatchNumber > visibleSwatchesCount[device].min) ||
		(swatchesTotalCount <= visibleSwatchesCount[device].max &&
			swatchNumber > visibleSwatchesCount[device].max)
	);
}

const StyledSwatch = styled(Swatch).attrs({
	className: 'fuse-complex-product-card__colour-swatch-item',
	'data-testid': 'fuse-complex-product-card__colour-swatch-item',
})`
	margin-left: var(--spacing-global-space1);
	@media screen and (min-width: ${breakpoints.m.minWidth}) {
		margin-left: var(--spacing-global-space2);
	}
	&:first-of-type {
		margin-left: 0;
	}
	${({ swatchNumber, swatchesTotalCount }) => `
		display: ${isSwatchInvisible(swatchNumber, swatchesTotalCount, 'xxs') ? 'none' : 'block'};

		@media screen and (min-width: ${breakpoints.xs.minWidth}) {
			display: ${isSwatchInvisible(swatchNumber, swatchesTotalCount, 'xs') ? 'none' : 'block'};
		}
		@media screen and (min-width: ${breakpoints.m.minWidth}) {
			display: ${isSwatchInvisible(swatchNumber, swatchesTotalCount, 'm') ? 'none' : 'block'};
		}
		@media screen and (min-width: ${breakpoints.l.minWidth}) {
			display: ${isSwatchInvisible(swatchNumber, swatchesTotalCount, 'l') ? 'none' : 'block'};
		}
		@media screen and (min-width: ${135 * 0.625}rem) {
			display: ${isSwatchInvisible(swatchNumber, swatchesTotalCount, '1350') ? 'none' : 'block'};
		}
	`}
`;

const StyledCountExtraExtraSmall = styled.span.attrs({
	className: 'fuse-complex-product-card__colour-swatch-count--extra-extra-small',
	'data-testid': 'fuse-complex-product-card__colour-swatch-count--extra-extra-small',
})`
	display: none;
	@media screen and (max-width: ${breakpoints.xxs.maxWidth}) {
		display: inline;
	}
`;

const StyledCountExtraSmall = styled.span.attrs({
	className: 'fuse-complex-product-card__colour-swatch-count--extra-small',
	'data-testid': 'fuse-complex-product-card__colour-swatch-count--extra-small',
})`
	display: none;
	@media screen and (min-width: ${breakpoints.xs.minWidth}) and (max-width: ${breakpoints.s
	.maxWidth}) {
		display: inline;
	}
`;

const StyledCountMedium = styled.span.attrs({
	className: 'fuse-complex-product-card__colour-swatch-count--medium',
	'data-testid': 'fuse-complex-product-card__colour-swatch-count--medium',
})`
	display: none;
	@media screen and (min-width: ${breakpoints.m.minWidth}) and (max-width: ${breakpoints.m
	.maxWidth}) {
		display: inline;
	}
`;

const StyledCountLarge = styled.span.attrs({
	className: 'fuse-complex-product-card__colour-swatch-count--large',
	'data-testid': 'fuse-complex-product-card__colour-swatch-count--large',
})`
	display: none;
	@media screen and (min-width: ${breakpoints.l.minWidth}) and (max-width: ${134.9 * 0.625}rem) {
		display: inline;
	}
`;

const StyledCountExtraLarge = styled.span.attrs({
	className: 'fuse-complex-product-card__colour-swatch-count--extra-large',
	'data-testid': 'fuse-complex-product-card__colour-swatch-count--extra-large',
})`
	display: none;
	@media screen and (min-width: ${135 * 0.625}rem) {
		display: inline;
	}
`;

export {
	ColourContainer,
	StyledSwatch,
	StyledCount,
	StyledCountExtraExtraSmall,
	StyledCountExtraSmall,
	StyledCountMedium,
	StyledCountLarge,
	StyledCountExtraLarge,
};
